<!-- 需求提报 -->
<template>
  <div>
    <!-- 搜索 -->
    <div class="container">
      <e-search
          :data="listQuery"
          :field-list="fieldList"
          :list-type-info="listTypeInfo"
          :width="listTypeInfo.width"
          @handleFilter="handleQuery"
          @handleReset="handleReset"
      ></e-search>
    </div>
    <!-- 操作按钮 -->
    <div class="container">
      <eTableList
          :table-data="tableData"
          :table-label="tableLabel"
          :index-show="true"
      >
        <template #commissionNumber="{scope}">
          <span @click="goCommissionSheet(scope.row)" class="theme">{{scope.row.commissionNumber}}</span>
        </template>
        <template #handle="{ scope }">
           <span v-if="scope.row.applyStatus === '214'"
                 @click="goPath(scope.row, '/ES/enterpriseInfoReview/review')"
                 class="table-handle-btn">
            审核
          </span>
          <span v-else class="table-handle-btn" @click="goPath(scope.row, '/ES/enterpriseInfoReview/details')">
            查看
          </span>
          <span class="table-handle-btn" @click="feedback(scope.row)">
            反馈
          </span>
        </template>
      </eTableList>
      <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :pager-count="5"
            :page-sizes="[10, 20, 30]"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="listQuery.pageNum"
            :total="total"
            :page-size.sync="listQuery.pageSize"
            prev-text="上一页"
            next-text="下一页"
        ></el-pagination>
      </div>
    </div>
    <feedback-dialog :visible.sync="visible" :details="info"/>
  </div>
</template>
<script>
  import eSearch from '@/modules/projectA/components/common/e-search';
  import eTableList from '@/modules/projectA/components/common/e-table-list';
  import feedbackDialog from './components/feedbackDialog';
  import Api from '@/modules/projectA/api/ESorganization';
  import {
    tableLabel,
    fieldList,
    listTypeInfo
  } from './components/componentsData.js';
  import { dateformate } from '../../../utils/utils';

  export default {
    components: { eSearch, eTableList, feedbackDialog },
    data() {
      return {
        tableLabel,
        fieldList,
        listTypeInfo,
        listQuery: {
          pageNum: 1,
          pageSize: 10,
          auditStatus: null,
          supplierType: null,
          reviewTimeOption: null
        },
        total: 0,
        cloneListQuery: {},
        tableData: [],
        info: {},
        visible: false
      };
    },
    created() {
      this.cloneListQuery = this.$options.data().listQuery;
      this.getList(this.listQuery);
    },

    methods: {
      /**
       * 点击反馈
       * @param data
       */
      feedback(data) {
        this.info = data;
        this.visible = true;
      },
      /**
       * 跳转产品质量评价工作委托单
       * @param applyId
       */
      goCommissionSheet({ applyId }) {
        const url = this.$router.resolve({
          path: '/ES/enterpriseInfoReview/commissionSheet',
          query: {
            applyId
          }
        }).href;
        window.open(url);
      },
      // 获取列表数据
      async getList(params) {
        this.tableLoading = true;
        await Api.queryApplyDataReviewPage({
          ...params,
          applyTimeBegin: params.applyTime ? dateformate(params.applyTime[0], 'yyyy-MM-dd') : undefined,
          applyTimeEnd: params.applyTime ? dateformate(params.applyTime[1], 'yyyy-MM-dd') : undefined,
          applyTime: undefined
        }).then(res => {
          this.tableLoading = false;
          if (res.code === '200') {
            const data = res.data;
            this.tableData = [...data?.records];
            this.total = data?.total;
          }
        });
      },

      // 更改页码
      handleCurrentChange(val) {
        this.listQuery.pageNum = val;
        this.getList(this.listQuery);
      },

      // 更改条数
      handleSizeChange(val) {
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getList(this.listQuery);
      },

      // 重置
      handleReset() {
        this.listQuery = { ...this.cloneListQuery };
        this.getList(this.listQuery);
      },

      // 搜索
      handleQuery(val) {
        this.listQuery = { ...val, pageNum: 1 };
        this.getList(this.listQuery);
      },

      goPath(row, path) {
        const { applyId, applyStatus } = row;
        this.$router.push({
          path,
          query: {
            applyId,
            applyStatus
          }
        });
      }
    },
    mounted() {
    }
  };
</script>
<style lang="scss" scoped>
  @import '@/assets/css/theme.scss';

  .theme {
    color: $main-col;
    cursor: pointer;
  }

  .table-handle-btn + .table-handle-btn {
    margin-left: 10px;
  }
</style>
